import type { ReactNode } from "react";

import { IconButton } from "@core/components/IconButton";
import type { LinkProps } from "@core/components/Link";
import { Link } from "@core/components/Link";
import type { SafeHtmlAttributes } from "@core/types/SafeHtmlAttributes";
import classnames from "classnames";

import { UiCrossIcon } from "@jti/brand-icons/ui-cross";

import styles from "./InfoBanner.module.scss";

export const INFO_BANNER_TONES = ["neutral", "success", "warning"] as const;

export type InfoBannerTone = (typeof INFO_BANNER_TONES)[number];

type InfoBannerDismissibleProps =
  | { isDismissible: true; dismissLabel: string; onDismiss: () => void }
  | { isDismissible?: false; dismissLabel?: never; onDismiss?: never };

export type InfoBannerProps = SafeHtmlAttributes<HTMLDivElement> &
  InfoBannerDismissibleProps & {
    tone?: InfoBannerTone;
    children: ReactNode;
    action?: LinkProps;
  };

export const InfoBanner = ({
  tone = "neutral",
  children,
  action,
  isDismissible = false,
  dismissLabel,
  onDismiss,
  ...rest
}: InfoBannerProps) => (
  <div {...rest} className={classnames(styles.infoBanner, styles[tone])} role="status">
    <div className={styles.contentWrapper}>
      <div className={styles.content}>
        <p className={styles.description}>{children}</p>
        {action && <Link {...action} />}
      </div>
      {isDismissible && <IconButton icon={UiCrossIcon} aria-label={dismissLabel} compact onClick={onDismiss} />}
    </div>
  </div>
);
